import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { useCookies } from "react-cookie";
import "../../styles/Settings.css";
import {Navigate, useNavigate} from "react-router-dom";

const decodeToken = (token) => {
    try {
        const payload = token.split(".")[1];
        return JSON.parse(atob(payload));
    } catch {
        return null;
    }
};

export default function Settings({ dark, setDark, sidebarOpen, setSidebarOpen }) {
    const [cookies, setCookie, removeCookie] = useCookies(["token"]);
    const [user, setUser] = useState(null);
    const toggleTheme = () => setDark(!dark);
    const [sessions, setSessions] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const loadSessions = async () => {
            const res = await fetch("https://api.industriegaming.fr/api/auth/sessions", {
                headers: { Authorization: `Bearer ${cookies.token}` }
            });

            // Si la session a été supprimée ou le token expiré
            if (res.status === 401) {
                removeCookie("token", { path: "/" });
                navigate("/");
                return;
            }

            const data = await res.json();
            setSessions(data);
        };

        loadSessions();
    }, []);

    const logoutSession = async (id) => {
        await fetch(`https://api.industriegaming.fr/api/auth/session/${id}`, {
            method: "DELETE",
            headers: { Authorization: `Bearer ${cookies.token}` }
        });

        setSessions(prev => prev.filter(s => s.id !== id));
    };

    const logoutAllSessions = async () => {
        await fetch(`https://api.industriegaming.fr/api/auth/sessions`, {
            method: "DELETE",
            headers: { Authorization: `Bearer ${cookies.token}` }
        });

        setSessions([]);
    };


    useEffect(() => {
        if (cookies.token) {
            const decoded = decodeToken(cookies.token);
            setUser(decoded);
        }
    }, [cookies.token]);

    return (
        <div className={`dashboard ${dark ? "dark" : ""}`}>
            <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            <div className="main">
                <Topbar onToggleSidebar={() => setSidebarOpen(true)} onToggleTheme={toggleTheme} dark={dark} />

                <div className="users-page">

                    {/* HEADER IDENTIQUE */}
                    <div className="users-header">
                        <div className="users-header-logo">
                            <h1>Paramètres</h1>
                        </div>
                    </div>

                    {/* CARD PROFIL */}
                    <div className="users-table-wrapper settings-card">
                        <h2 className="chart-title">Profil</h2>

                        <div className="settings-row">
                            <label>Nom d'utilisateur</label>
                            <input type="text" value={user?.name || ""} disabled />
                        </div>

                        <div className="settings-row">
                            <label>Rôle</label>
                            <input type="text" value={user?.role || ""} disabled />
                        </div>
                    </div>

                    {/* CARD APPARENCE */}
                    <div className="users-table-wrapper settings-card">
                        <h2 className="chart-title">Apparence</h2>

                        <div className="settings-row">
                            <label>Thème</label>
                            <select value={dark ? "dark" : "light"} onChange={toggleTheme}>
                                <option value="light">Clair</option>
                                <option value="dark">Sombre</option>
                            </select>
                        </div>
                    </div>

                    {/* CARD SÉCURITÉ */}
                    <div className="users-table-wrapper settings-card">
                        <h2 className="chart-title">Sécurité</h2>

                        <div className="settings-row">
                            <label>Connexions actives</label>
                        </div>

                        <table className="users-table">
                            <thead>
                            <tr>
                                <th>Appareil</th>
                                <th>Adresse IP</th>
                                <th>Connecté depuis</th>
                                <th>Actions</th>
                            </tr>
                            </thead>

                            <tbody>
                            {sessions.map((s) => (
                                <tr key={s.id}>
                                    <td>{s.device}</td>
                                    <td>{s.ip}</td>
                                    <td>{new Date(s.createdAt).toLocaleString()}</td>
                                    <td className="actions">
                                        {/*{s.token !== cookies.token && (*/}
                                            <button
                                                className="delete-btn"
                                                onClick={() => logoutSession(s.id)}
                                            >
                                                🗑️
                                            </button>
                                        {/*)}*/}
                                        {/*{s.token === cookies.token && (*/}
                                        {/*    <span>Session Actuelle</span>*/}
                                        {/*)}*/}
                                            </td>
                                            </tr>
                                            ))}

                                        {/* Lignes vides pour garder la hauteur */}
                                        {Array.from({ length: 5 - sessions.length }).map((_, i) => (
                                <tr key={`empty-${i}`} className="empty-row">
                                    <td colSpan="4"></td>
                                </tr>
                            ))}
                            </tbody>
                        </table>

                        <button className="add-user-btn" onClick={logoutAllSessions}>
                            Déconnecter toutes les sessions
                        </button>
                    </div>


                </div>
            </div>
        </div>
    );
}
